import { MyBundleStatus, Web3Address } from 'multirpc-sdk';

import { MultiService } from 'modules/api/MultiService';
import { RequestType, web3Api } from 'store/queries';
import { createNotifyingQueryFn } from 'store/utils/createNotifyingQueryFn';
// import { fetchMyBundlesStatusMockData } from './mocks/fetchMyBundlesStatusMockData'; // use for debugging

interface IFetchMyBundlesStatusParams {
  group?: Web3Address;
}

// The endpoint name is listed in endpointsSerializedByParams constant
// in packages/protocol/src/store/queries/index.ts file.
// If the name has changed it should be reflected there as well.
export const {
  endpoints: { fetchMyBundlesStatus },
  useFetchMyBundlesStatusQuery,
} = web3Api.injectEndpoints({
  endpoints: build => ({
    fetchMyBundlesStatus: build.query<
      MyBundleStatus[],
      IFetchMyBundlesStatusParams
    >({
      providesTags: [RequestType.MyBundles],
      queryFn: createNotifyingQueryFn(async ({ group }) => {
        const api = MultiService.getService().getAccountingGateway();

        const data = await api.getMyBundlesStatus(group);

        // return { data: fetchMyBundlesStatusMockData }; // use for debugging
        return { data };
      }),
    }),
  }),
  overrideExisting: true,
});
